import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from "../../../../Common";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi, { x } from "@hapi/joi";
import { FieldFactoryCheckrollWeightReportSchemaObject } from "../FieldFactoryCheckrollWeightReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from "./createPdf";
import _, { isNumber } from "lodash";
import "../../../Common/Table/table.css";
import xlsx from "json-as-xlsx";
import moment from "moment";
import WeightReportTable, { gainPercentage, formatPercentage } from "./weightReportTable";
import MessageModal from "../../../../UI/Modal/MessageModal";

const screenCode = "FIELDFACTORYCHECKROLLWEIGHTREPORT";

export function FieldFactoryCheckrollWeightReportListing(props) {
  const componentRef = useRef();
  const [groups, setGroups] = useState([]);
  const [estates, setEstates] = useState([]);
  const [multipleEstates, setMultipleEstates] = useState([]);

  const [isTableHide, setIsTableHide] = useState(true);

  const [weightDetails, setWeightDetails] = useState({
    groupID: "0",
    estateID: "0",
    searchMonth: new Date().toISOString().slice(0, 7),
  });

  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupID: "0",
    estateID: "0",
    searchMonth: "",
  });

  const [errors, setErrors] = useState({});

  const [permissionList, setPermissions] = useState({
    isAddEditEnabled: false,
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });

  const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
  const [buttonHide, setButtonHide] = useState(true);

  const schema = Joi.object(FieldFactoryCheckrollWeightReportSchemaObject).options({
    allowUnknown: true,
  });

  const [csvHeaders, setCsvHeaders] = useState([
    { label: "Date", value: "date" },
    { label: "Collection Point Name", value: "collectionPointName" },
    { label: "Field Weight", value: "fieldWeight" },
    { label: "Factory Weight", value: "factoryWeight" },
    { label: "Checkroll Weight", value: "checkrollWeight" },
    { label: "FI/FA Difference", value: "fifa" },
    { label: "FI/FA %", value: "fifaPercent" },
    { label: "FA/CR Difference", value: "facr" },
    { label: "FA/CR %", value: "facrPercent" },
  ]);

  const [reportData, setReportData] = useState([]);
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "",
    disciption: "",
  });

  useEffect(() => {
    trackPromise(getPermissions(), getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getEstatesForDropdown());
  }, [weightDetails.groupID]);

  useEffect(() => { }, [reportData]);

  function handleGroupChange(target) {
    validateInputs(target);

    setWeightDetails({
      ...weightDetails,
      groupID: target.value,
      estateID: "0",
    });
  }

  function handleEstateChange(target) {
    validateInputs(target);

    setReportData([]);
    setIsTableHide(true);
    setIsReportButtonsEnabled(false);
    setButtonHide(true);

    setWeightDetails({
      ...weightDetails,
      estateID: target.value,
      searchMonth: new Date().toISOString().slice(0, 7),
    });
  }


  function handleSearchMonthChange(target) {
    setReportData([]);
    validateInputs(target);
    setWeightDetails({
      ...weightDetails,
      searchMonth: target.value,
    });
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(
      target,
      FieldFactoryCheckrollWeightReportSchemaObject
    );
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setErrors(error);
  }

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);

    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "VIEWFIELDFACTORYCHECKROLLWEIGHTREPORT"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }
    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );

    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });
    var token = tokenService.getUserDetailsFromTokenV2();

    if (token.operationEntities.length > 0) {

      var estateArray = [];
      for (let item of Object.entries(token.operationEntities)) {
        estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
      }

      setMultipleEstates(estateArray)

      setWeightDetails({
        ...weightDetails,
        groupID: token.groupID
      });

    } else {
      setWeightDetails({
        ...weightDetails,
        groupID: token.groupID,
        estateID: token.operationEntityID,
      });
    }

    setWeightDetails({
      ...weightDetails,
      groupID: token.groupID,
      estateID: token.operationEntityID,
    });
    trackPromise(getGroupsForDropdown());
  }

  async function getGroupsForDropdown() {
    const result = await services.getAlGroupsForDropdown();
    setGroups(result);
  }

  async function getEstatesForDropdown() {
    const data = await services.getEstatesByGroupID(
      weightDetails.groupID
    );
    setEstates(data);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }
  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }
  async function handleSearch(e) {
    e.preventDefault();
    setIsTableHide(true);

    const errorMessages = validate(schema, weightDetails)
    errorMessages !== null ? setErrors(errorMessages) : setErrors({})
    if (errorMessages) return;

    getSelectedDropdownValuesForReport(weightDetails);
    var reportData = await services.GetFieldFactoryCheckrollWeightReportData(weightDetails);
    if (reportData.length > 0) {

      setReportData(reportData);
      setIsTableHide(false);
      destroyDataTable();
      setIsReportButtonsEnabled(true);
      setButtonHide(false);
    } else {
      setMessageModel({
        ...messageModel,
        hidden: false,
        type: "Error",
        disciption: "No Records To Display",
      });
      setTimeout(() => {
        modalDismissHandler();
      }, 3000);
    }
  }


  function createFile() {
    var settings = {
      sheetName: "Field Factory Report",
      fileName: "Field Factory Checkroll Weight Report",
      writeOptions: {},
    };

    var dataForExcel = [...reportData]
      .sort((a, b) => a.collectionPointID - b.collectionPointID)
      .reduce((acc, item) => {
        [...item.data]
          .sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate))
          .forEach((element) => {
            acc.push({
              date: new Date(element.createdDate).toLocaleDateString("en-GB"),
              collectionPointName: item.collectionPointName,
              fieldWeight: element.fieldWeight,
              factoryWeight: element.factoryWeight,
              checkrollWeight: element.checkrollWeight,
              fifa: element.fieldWeight - element.factoryWeight,
              fifaPercent: formatPercentage(gainPercentage(element.fieldWeight, element.factoryWeight)),
              facr: element.factoryWeight - element.checkrollWeight,
              facrPercent: formatPercentage(gainPercentage(element.factoryWeight, element.checkrollWeight)),
            });
          });
        return acc;
      }, []);

    var copyOfCsv = _.cloneDeep(dataForExcel);

    copyOfCsv.push({});

    copyOfCsv.push({
      date: "Group :" + groups[weightDetails.groupID],
      factoryWeight: "Operation Entity : " + estates[weightDetails.estateID],
      facr: "Month : " + weightDetails.searchMonth,
    });

    xlsx(csvHeaders, copyOfCsv, settings, true);
  }



  function destroyDataTable() {
    $("#example3").DataTable().destroy();
  }

  function onClearClick() {
    clearState();
  }

  function clearState() {
    setWeightDetails({
      ...weightDetails,
      searchMonth: new Date().toISOString().slice(0, 7),
    });
    setReportData([]);
    setIsTableHide(true);
    setErrors("");
    setIsReportButtonsEnabled(false);
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      group: groups[searchForm.groupID],
      estate: estates[searchForm.estateID],
      searchMonth: searchForm.searchMonth,
    });
  }

  function computeToDateGain(data) {
    const days = {};
    data.forEach((item) => {
      item.data.forEach((el) => {
        const key = moment(el.createdDate).format("YYYY-MM-DD");
        if (!days[key]) days[key] = { field: 0, factory: 0, checkroll: 0 };
        days[key].field += el.fieldWeight || 0;
        days[key].factory += el.factoryWeight || 0;
        days[key].checkroll += el.checkrollWeight || 0;
      });
    });

    const completeKeys = Object.keys(days)
      .filter((k) => days[k].field > 0 && days[k].factory > 0 && days[k].checkroll > 0)
      .sort();

    if (completeKeys.length === 0) return { fifa: null, facr: null, upTo: null };

    const totals = completeKeys.reduce(
      (t, k) => ({
        field: t.field + days[k].field,
        factory: t.factory + days[k].factory,
        checkroll: t.checkroll + days[k].checkroll,
      }),
      { field: 0, factory: 0, checkroll: 0 }
    );

    return {
      fifa: gainPercentage(totals.field, totals.factory),
      facr: gainPercentage(totals.factory, totals.checkroll),
      upTo: moment(completeKeys[completeKeys.length - 1]).format("DD/MM/YYYY"),
    };
  }

  function gainColor(value) {
    if (value === null) return undefined;
    return value < 0 ? "#d32f2f" : value > 0 ? "#2e7d32" : undefined;
  }

  const toDateGain = reportData.length > 0 ? computeToDateGain(reportData) : null;

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <PageHeader
              title="Field Factory Checkroll Weight Report"
              isButtonEnable={permissionList.isAddEditEnabled}
            />
            <div className="card-body">
              <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                <div className="form-group row">
                  <div className="col-md pb-1">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="groupID"
                      id="groupID"
                      name="groupID"
                      value={weightDetails.groupID}
                      disabled={!permissionList.isGroupFilterEnabled}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText error>{errors["groupID"]}</FormHelperText>
                    )}
                  </div>
                  <div className="col-md pb-1">
                    <InputLabel shrink id="estateID">
                      Operation Entity*
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="estateID"
                      id="estateID"
                      name="estateID"
                      value={weightDetails.estateID}
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      onChange={(e) => handleEstateChange(e.target)}
                    >
                      <MenuItem value="0">--Select Estate--</MenuItem>
                      {generateDropDownMenu(
                        Object.fromEntries(
                          Object.entries(estates).filter(([key, value]) => {
                            if (key === "0" || !value) return false;
                            if (!multipleEstates || Object.keys(multipleEstates).length === 0) {
                              return true;
                            }
                            return Object.values(multipleEstates).includes(value);
                          })
                        )
                      )}
                    </Select>
                    {errors["estateID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["estateID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md pb-1">
                    <InputLabel shrink id="searchMonth">
                      Search Month *
                    </InputLabel>
                    <TextField
                      fullWidth
                      id="searchMonth"
                      name="searchMonth"
                      type="month"
                      value={weightDetails.searchMonth}
                      onChange={(e) => handleSearchMonthChange(e.target)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors["searchMonth"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["searchMonth"]}
                      </FormHelperText>
                    )}
                  </div>
                </div>
                <div className="card-footer">
                  <input
                    disabled={validate(schema, weightDetails)}
                    type="button"
                    className="btn btn-primary"
                    value="Search"
                    onClick={(e) => trackPromise(handleSearch(e))}
                  />

                  <input
                    type="reset"
                    className="btn btn-warning pull-right"
                    value="CLEAR"
                    onClick={onClearClick}
                  />
                </div>
              </form>
              {reportData.length > 0 ? (
                <Fragment>
                  <div className="row mt-3 mb-3 ml-2">
                    {[
                      { label: "FI/FA %", value: toDateGain.fifa },
                      { label: "FA/CR %", value: toDateGain.facr },
                    ].map((box, i) => (
                      <div className="col-12 col-md-4 mb-3" key={i}>
                        <div
                          style={{
                            border: "1px solid #e0e0e0",
                            borderRadius: "8px",
                            padding: "15px 30px",
                            height: "100%",
                            backgroundColor: "#fff",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <div style={{ fontSize: "14px", color: "#666", fontWeight: 500, marginBottom: "5px" }}>
                              To-Date Gain %{toDateGain.upTo ? ` (up to ${toDateGain.upTo})` : ""}
                            </div>
                            <div style={{ fontSize: "16px", fontWeight: "bold", color: "#333" }}>
                              {box.label}
                            </div>
                          </div>
                          <div style={{ fontSize: "22px", fontWeight: "bold", color: gainColor(box.value) || "#555" }}>
                            {formatPercentage(box.value)}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <WeightReportTable data={reportData} selectedMonth={weightDetails.searchMonth} />
                </Fragment>
              ) : null}


            </div>
            {reportData.length != 0 ? (
              <div className="pt-2">
                <ReactToPrint
                  documentTitle={"Field Factory Checkroll Weight Report"}
                  trigger={() => (
                    <input
                      type="button"
                      className="btn btn-primary pull-right ml-2"
                      value="PDF"
                    />
                  )}
                  content={() => componentRef.current}
                />
                <div hidden={true}>
                  <CreatePdf
                    ref={componentRef}
                    reportData={reportData}
                    searchData={selectedSearchValues}
                    toDateGain={toDateGain}
                  />
                </div>{" "}
                <input
                  type="button"
                  className="btn btn-primary pull-right ml-2"
                  value="Excel"
                  onClick={createFile}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
        clicked={modalDismissHandler}
      />
    </Fragment>
  );
}
